var Handlebars = require("../../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";

  return "<div class=\"esPgNum\">"
    + container.escapeExpression(((helper = (helper = helpers.pgLbl || (depth0 != null ? depth0.pgLbl : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pgLbl","hash":{},"data":data}) : helper)))
    + "</div><div class=\"esPageText\">"
    + ((stack1 = ((helper = (helper = helpers.pgText || (depth0 != null ? depth0.pgText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pgText","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/content/pages/page/template.hbs
 ** module id = 543
 ** module chunks = 0
 **/